import { localizationData, defaultLanguage, enabledLanguages } from '../../../Intl/setup';
import { getUserPreference, setUserPreferenceRequest } from '../User/UserActions';
import { setDateLanguage } from '../../util/date';

// Export Constants
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';


export function initLanguage(lang = null, user = null, store = null) {
    console.log('initLanguage', lang);
    return dispatch => {
        return new Promise((resolve, reject) => {
            if(!lang) {
                if(store && store.intl && store.intl.isInit) {
                    lang = store.intl.locale;
                } else if(global.navigator && global.navigator.language) {
                    const navigatorLanguage = global.navigator.language.split('-')[0];
                    lang = navigatorLanguage;
                }
                // const initLocale = global.navigator && global.navigator.language || 'en';
            }
            if(enabledLanguages.indexOf(lang) === -1) {
                // console.log('lang not enabled!', lang);
                lang = defaultLanguage;
            }
            dispatch(switchLanguage(lang));
            if(user && lang && localizationData[lang] && lang !== getUserPreference(user, 'language')) {
                dispatch(setUserPreferenceRequest('language', lang));
            }
            // console.log('Lang set', lang);
            resolve(lang);
        });
    };
}

export function getEnabledLanguages() {
    return enabledLanguages;
}

// @TODO:
// Browser: Check cookie to retrieve prefered language in case of missing in url
// Node: Check request
export function getPreferedLanguage() {
    return null;
}

export function getCountryFromLanguage(lang) {
    switch(lang) {
        case 'en':
            return 'GB';

        default:
            return lang && lang.toUpperCase();
    }
}

export function getTranslation(model, field, lang) {
    if(model) {
        if(lang !== defaultLanguage && model.translations) {
            const translation = model.translations.find(translation => translation.lang === lang);
            if(translation && translation[field]) {
                return translation[field];
            }
        }
        return model[field];
    }
    return '';
}

export function getLanguagePath(path, lang = defaultLanguage) {
    enabledLanguages.forEach(language => {
        if(path.indexOf(`/${language}/`) !== -1) {
            path = path.replace(`/${language}/`, '/');
        // } else if(path.indexOf(`/${language}`) !== -1) {
        //     path = path.replace(`/${language}`, '/');
        }
    });
    // console.log(path);
    return `/${lang}${path}`;
}

export function switchLanguage(newLang) {
    if(newLang && localizationData[newLang]) {
        setDateLanguage(newLang);

        return {
            type: SWITCH_LANGUAGE,
            ...localizationData[newLang],
            isInit: true,
        };
    }
    return {
        type: SWITCH_LANGUAGE,
        ...localizationData[defaultLanguage],
    };
}
